import { __extends } from "tslib";
import { fetchSoftware } from '@gn-audio/core/api/knowledge-base';
import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
import { SoftwareItem } from '../models/software-item';
import { SoftwareType } from '../models/software-type';
import { ContactSupportSectionController } from 'src/Feature/ContactSupport/app';
import { makeUrlDomainIndependent } from 'src/Foundation/Design/app';
var SoftwareSpotController = (function (_super) {
    __extends(SoftwareSpotController, _super);
    function SoftwareSpotController($scope, $q, siteLanguage, productContextService, dynamicPagesSpotsDisplayOptionsService) {
        var _this = _super.call(this, $scope, productContextService, dynamicPagesSpotsDisplayOptionsService, GroupRestrictedSpotType.Other) || this;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.siteLanguage = siteLanguage;
        _this.initialize();
        _this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                _this.$scope.softwareItems = [];
                return;
            }
            _this.$scope.promise = _this.$q.when(fetchSoftware(group.groupId))
                .then(function (softwareItems) {
                _this.$scope.softwareItems = (softwareItems || []).map(function (si) {
                    si.fileUrl = makeUrlDomainIndependent(si.fileUrl || '');
                    return new SoftwareItem(si);
                });
            });
        });
        _this.$scope.$on('release-notes', function (event, releaseNotes) {
            _this.$scope.releaseNotes = releaseNotes;
        });
        _this.$scope.$on('has-application', function (event, hasApplication) {
            _this.$scope.hasApplication = hasApplication;
        });
        _this.$scope.$watch('softwareItems', function () {
            _this.$scope.softwareTypes.length = 0;
            var firmwareItems = _this.$scope.softwareItems
                .filter(function (x) { return x.documentType && x.documentType.indexOf('Firmware') > -1; });
            if (firmwareItems.length > 0) {
                _this.$scope.softwareTypes.push(new SoftwareType(firmwareItems, _this.siteLanguage));
                _this.$scope.softwareTypes[_this.$scope.softwareTypes.length - 1].title = 'Firmware';
            }
            var softwareItems = _this.$scope.softwareItems
                .filter(function (x) { var _a; return ((_a = x.documentType) === null || _a === void 0 ? void 0 : _a.indexOf('Firmware')) === -1 && x.documentType !== 'App'; });
            if (softwareItems.length > 0) {
                _this.$scope.softwareTypes.push(new SoftwareType(softwareItems, _this.siteLanguage));
                _this.$scope.softwareTypes[_this.$scope.softwareTypes.length - 1].title = 'Software';
            }
            var appItems = _this.$scope.softwareItems.filter(function (si) { return si.documentType === 'App'; });
            if (appItems.length > 0) {
                _this.$scope.softwareTypes.push(new SoftwareType(appItems, _this.siteLanguage));
                _this.$scope.softwareTypes[_this.$scope.softwareTypes.length - 1].title = 'Apps';
            }
        });
        return _this;
    }
    SoftwareSpotController.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        this.$scope.sectionVisible = function () {
            var hasSoftware = Array.isArray(_this.$scope.softwareItems) && _this.$scope.softwareItems.length > 0;
            var hasReleaseNotes = Array.isArray(_this.$scope.releaseNotes) && _this.$scope.releaseNotes.length > 0;
            return hasSoftware || hasReleaseNotes || _this.$scope.hasApplication;
        };
    };
    SoftwareSpotController.prototype.initialize = function () {
        this.$scope.softwareItems = [];
        this.$scope.softwareTypes = [];
    };
    SoftwareSpotController.$inject = [
        '$scope',
        '$q',
        'siteLanguage',
        'productContextService',
        'dynamicPagesSpotsDisplayOptionsService',
    ];
    return SoftwareSpotController;
}(ContactSupportSectionController));
export { SoftwareSpotController };
